<template>
  <div>
    <b-row class="my-3">
      <b-col cols="4">
        <b-row v-if="getRestorationTask != null">
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">#</th>
                    <th class="px-2 py-1">File Name</th>
                    <th class="px-2 py-1 float-end">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(file, idx) in getRestorationTask.attachments" :key="idx" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{idx + 1}}</td>
                    <td class="px-2 py-1 text-capitalize">{{file.description || file.name}}</td>
                    <td class="px-2 py-1">
                      <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
        <b-col cols="8">
        <RestorationAttachments ref="attachmentScreen"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import server from "@/app/env/server.json";
import RestorationAttachments from "@/views/home/services/restorations/task/RestorationAttachments";

export default {
  name: "RestorationFiles",
  components: {RestorationAttachments},
  data(){
    return{
      attachmentUrl:null
    }
  },
  mounted() {
    // if (this.getRestorationTask.restoration.restorationAttachment[0] !== undefined) {
    //   this.openFile(this.getRestorationTask.restoration.restorationAttachment[0])
    // }
    if (this.getRestorationTask.attachments && this.getRestorationTask.attachments.length > 0) {
  this.openFile(this.getRestorationTask.attachments[0]);
  console.log("Opened first attachment on mount", this.getRestorationTask.attachments[0]);
}
  },
  methods:{
    ...mapActions(["fetchAddressByVillageId"]),
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    openFile(data){
      this.attachmentUrl = null;
      this.attachmentUrl = server.IP+"/data-update/companies/download?file-name="+data.fileName+"&token="+sessionStorage.getItem("access_token").replaceAll("\"", "")
    },
    cleanName(name){
      let n = name.replaceAll("_", " ")
      return n.toLowerCase()
    },
  },
  computed:{
    ...mapGetters(["getRestorationTask", "getAddress"])
  },
  watch:{
  getRestorationTask(data) {
    if (data?.attachments?.length > 0) {
      this.openFile(data.attachments[0]);
    }
  },
    attachmentUrl:{
      handler(url){
        if (url !== null) {
          this.$refs.attachmentScreen.openFile(url)
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>

th, td{
  font-size: 12px;
}

</style>